import { SHOW_CONFIRM_MODAL, CLOSE_CONFIRM_MODAL } from './confirmation-modal-actions';

const initialState = {
    show: false,
    numActivitiesAssigned: 0,
    classRoomName: '',
    groupName: '',
    displayInfo: {},
    dismissManner: {}
};
/*
* numberOfActivitiesAssigned,
 className: requestData.selectedClass.name,
 groupName
 */
export default function (state = initialState, action) {
    const type = action.type;
    const payload = action.payload;

    switch (type) {
    case SHOW_CONFIRM_MODAL:
        return {
            ...state,
            ...payload,
            show: true
        };
    case CLOSE_CONFIRM_MODAL:
        return {
            ...state,
            ...payload,
            show: false
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/confirmation-modal/confirmation-modal-reducer.js